import React, { useEffect } from "react";
import { Grid, theme } from "antd";
import BrandColors from "@brand-colors";
import whitelabelConfig from "@whitelabel-config";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useSelector } from "react-redux";
const { useToken } = theme;
const { useBreakpoint } = Grid;
const FooterDefault = (props: any) => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const { t } = useTranslation();
    const uiState = useSelector((state: any) => state.portal.uiState);
  console.log("whitelabelConfig.uiSettings.isLogoEnable......",typeof(whitelabelConfig.uiSettings.enablePrivacy))
    useEffect(() => {
      console.log("uiState.Language", uiState.Language);
      i18n.changeLanguage(uiState.Language);
   
    }, []);
  const styles = {
    container: {
      alignItems: "center",
      display: "flex",
      flexDirection: screens.md ? "row" : "column",
      justifyContent: "space-between",
      margin: "0 auto",
      maxWidth: token.screenXL,
      padding: screens.md
        ? `7px ${token.paddingLG}px`
        : `7px ${token.padding}px`,
    },
    footer: {
      backgroundColor: BrandColors.FOOTER_BG,
      borderTop: `${token.lineWidth}px ${token.lineType} ${token.colorSplit}`,
      position: "fixed",
      bottom: "0",
      width: "100%",
      minHeight: "30px",
    },
    nav: {
      alignItems: "center",
      marginLeft: screens.md ? `-${token.margin}px` : 0,
    },
    text: {
      color: BrandColors.FOOTER_COLOR,
      textAlign: screens.md ? "right" : "center",
      fontSize: "12px",
    },
    privacy: {
      color: BrandColors.FOOTER_COLOR,
      fontSize: "12px",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    footerInner: {
      display: "flex",
      justifyContent: screens.md ? "flex-end" : "space-between",
      alignItems: "center",
      width: "100%",
    },
    copyright: {
      order: screens.md ? "" : "2",
    },
  };
  const currentYear = new Date().getFullYear();
  const productName = process.env.REACT_APP_PRODUCT;
  return (
    <footer style={styles.footer as any}>
      <div style={styles.container as any}>
        <div>
          {whitelabelConfig.uiSettings.isLogoEnable === true && (
            <img
              src="{{env.isLogoEnable ? 'assets/img/sagitec.png' : 'assets/img/brand_empty.png'}}"
              alt={t("FOOTER.LOGO_ALT", { defaultValue: "Brand logo" })}
            />
          )}
        </div>
        <div style={styles.footerInner as any}>
          <div style={styles.copyright as any}>
            {whitelabelConfig.uiSettings.enableCopyright === true && (
              <span style={styles.privacy} id="footer-copyright" tabIndex={0} role="article" aria-label="footer-copyright">
                {t("GLOBAL.COPYRIGHT_CONTENT") + " "}
                {`${currentYear} - ${productName}`}
                {t("GLOBAL.COPYRIGHT_CONTENT_END", {
                  VERSION: process.env.REACT_APP_VERSION,
                })}
              </span>
            )}
          </div>

          <div tabIndex={0} role="article" aria-label="footer-privacy">
            {whitelabelConfig.uiSettings.enablePrivacy === true && (
              <a
                id="footer-privacy"                
                style={styles.privacy as any}
                href={t("FOOTER.PRIVACY_URL")}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${t("GLOBAL.PRIVACY_CONTENT")} (${t("GLOBAL.OPENS_NEW_TAB", { defaultValue: "opens in new tab" })})`}
              >
                {t("GLOBAL.PRIVACY_CONTENT")}{" "}
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterDefault;
